import PropTypes from "prop-types"
import { DATE } from "helpers/shapes"
import { formatLongDate } from "helpers/formatters/dates"
import DailyDetails from "modules/factor-trends/components/daily-details"
import "./style.scss"

function FactorTrendsPerformanceDetails({
  selectedDate,
  details,
  openFactorProfile,
  sort,
  order,
  csvData,
  driftArrows,
}) {
  return <div className="modules_factor-trends-performance-details">
    <h4 className="header">As of {formatLongDate(selectedDate)}</h4>
    <DailyDetails {...{
      calculationType: "performance",
      openFactorProfile,
      noFactorDrilldown: true,
      data: details,
      factorTable: true,
      sort,
      order,
      csvData,
      driftArrows,
    }}
    />
  </div>
}

FactorTrendsPerformanceDetails.propTypes = {
  startDate: DATE.isRequired,
  selectedDate: DATE.isRequired,
  details: PropTypes.array.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  sort: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  csvData: PropTypes.shape({
    data: PropTypes.array,
    fileName: PropTypes.string,
    type: PropTypes.string,
  }),
  driftArrows: PropTypes.object,
}

export default FactorTrendsPerformanceDetails
